import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

document.addEventListener('DOMContentLoaded', function () {
  const restrictedVariantIds = [47279534768380, 47255809229052, 47392526696700];

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      restrictedVariantIds.forEach((variantId) => {
        const alreadyInCart = cart.items.some(item => item.variant_id === variantId);

        if (alreadyInCart) {
          const form = document.querySelector(`form[action="/cart/add"] input[value="${variantId}"]`)?.closest('form');
          if (form) {
            const addBtn = form.querySelector('.add-to-cart-button');
            const altBtn = form.querySelector('.limit-reached-btn');

            if (addBtn) {
              addBtn.disabled = true;
              addBtn.textContent = 'Limit Reached';
            }

            if (altBtn) {
              altBtn.style.display = 'flex';
            }
          }
        }
      });
    });
});